/*
 * Short text field component
 */
import React from 'react';

import Base from './base.jsx';
import {
  DataType,
  Mode,
  Format,
  castDataType,
  NumericalValidationLimits,
  NumberFormatting,
} from '../common.jsx';
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";
import FlatpickrInput from '../../common/FlatpickrInput.jsx';

export default class TextField extends Base {

        static get CATEGORY() {
            return 'question';
        }

        static get TYPE() {
            return 'text_field';
        }

        static icon(){
            return <i className="fa fa-i-cursor"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'field_default_label',
                placeholder: 'field_default_placeholder',
                description: 'field_default_description',
                help: null,
                unit: null
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                label: 'label',
                placeholder: 'placeholder',
                description: 'description',
                name: 'field_' + Helpers.randomString(),
                reportKey: '',
                help: 'help',
                required: false,
                label_hidden: false,
                dataType: DataType.STRING,
                validations: {},
                charLimit: 0,
                currency: false,
                numberFormatting: NumberFormatting.NONE,
                lockEditWhenPrefilled: false,
                unit: 'unit',
                sourcesOfPrefill: '',
                prettyView: {
                    hide: false,
                    show_label: false
                }
            });
        }

        static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = '') {
            const dependencies = []
            content.dependencyMapping?.map((v) => dependencies.push(repeatedFieldScope + '[' + v.componentId + ']'));
            if (content.datagridRowLookupDependency) {
              dependencies.push(repeatedFieldScope + '[' + content.datagridRowLookupDependency + ']')
            }
            return [...(super.resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope) || []), ...(dependencies || [])];
        }

        static compatiblePrefillComponents() {
          return ['text_field', 'dropdown_selection', 'number_field'];
        }
      
        static compatiblePrefillDataTypes() {
          return [DataType.INTEGER, DataType.DECIMAL, DataType.DATE, DataType.STRING];
        }

        componentDidMount() {
            super.componentDidMount();
            this.componentDidUpdate();
        }

        componentDidUpdate() {
            super.componentDidUpdate();

            if (this.props.mode == Mode.SETTINGS) {
                if (this.props.content.dataType == DataType.DATE) {
                    if (!(jQuery(this.refs.validateMin)[0] || [])._flatpickr ||  !(jQuery(this.refs.validateMax)[0] || [])._flatpickr){
                        jQuery(this.refs.validateMin).add(this.refs.validateMax).flatpickr({
                            dateFormat: "Y-m-d", 
                            allowInput: true,
                            onChange: (selectedDates, dateStr, instance) => {
                                this.updateSettings(dateStr)
                        }});
                    }
                } else {
                    // Remove flatpickr when other input type is selected
                    try {
                        if (jQuery(this.refs.validateMin)[0] && jQuery(this.refs.validateMin)[0]._flatpickr) {
                            jQuery(this.refs.validateMin)[0]._flatpickr.destroy();
                        }
                        if (jQuery(this.refs.validateMax)[0] && jQuery(this.refs.validateMax)[0]._flatpickr) {
                            jQuery(this.refs.validateMax)[0]._flatpickr.destroy();
                        }
                    } catch (e){
                        // No probs. It was not initialised.
                    }
                }
            } else if (this.props.mode == Mode.FILL || this.props.mode == Mode.VIEW) {
                if (this.props.content.dataType == DataType.INTEGER || this.props.content.dataType == DataType.DECIMAL || this.props.content.dataType == DataType.STRING) {
                    if (this.props.content.numberFormatting === NumberFormatting.CURRENCY) {
                        new Helpers.CurrencyFormatter(this.refs.input, {
                            format: document.body.getAttribute("data-currency-format"),
                            readOnly: this.props.mode != Mode.FILL || this.isReadOnlyAnswer()
                        });
                    }
                    else if (this.props.content.numberFormatting === NumberFormatting.NUMBER) {
                        let format = document.body.getAttribute("data-number-format");

                        if (format === '1 000.0…') format = 'default'
                        else if (format === '1 000,0…') format = 'format_1'
                        else if (format === '1,000.0…') format = 'format_2'
                        else if (format === '1.000,0…') format = 'format_3'

                        Helpers.CurrencyFormatter.remove(this.refs.input);

                        new Helpers.CurrencyFormatter(this.refs.input, {
                            format: format,
                            readOnly: this.props.mode != Mode.FILL || this.isReadOnlyAnswer()
                        });
                    }  
                }
            }
            if (this.props.content && this.props.content.dataType == DataType.STRING) {
                if (this.props.content.charLimit && this.props.mode != Mode.VIEW) {
                    new Helpers.TextareaCounter(this.refs.input, {
                        type: 'char',
                        limit: this.props.content.charLimit
                    });
                } else {
                    Helpers.TextareaCounter.remove(this.refs.input);
                }
            }
        }

        renderView() {
            let unit = this.getText('unit') || '';
            let validationFailures = this.getFormValidationFailures();

            const disabled = this.props.content.disabled === true;
            const readOnly = this.props.mode != Mode.FILL || this.isReadOnlyAnswer();
            return (
                <div>
                    {this.getLockedInformationTooltip(this.modeFillOrView() && this.isReadOnlyPrefilledAnswer(), <>
                        <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                            <span className="field-label">{this.getText('label')}</span>
                            {this.props.content.required ? <span className='required-field'> *</span> : null}
                            {this.helpIcon()}
                            {this.renderPrefillIcon()}
                            <div className="input-container">
                                <div className={unit.length > 0 ? 'input-group' : null}>
                                    {this.props.content.dataType == DataType.DATE ?
                                        // Controlled date input instead of updating prefilled values with random key
                                        <FlatpickrInput
                                            key={this.fullFieldName()}
                                            className={validationFailures.length > 0 ? `form-control has-error warning-tooltip ${this.isReadOnlyAnswer() ? 'locked' : ''} ${this.getInputClassNames()}` : `form-control ${this.isReadOnlyAnswer() ? 'locked' : ''} ${this.getInputClassNames()}`}
                                            name={this.fullFieldName()}
                                            value={this.getRawAnswer()}
                                            title={validationFailures.length > 0 ? validationFailures.join('\n') : ''}
                                            data-validation={validationFailures.length > 0}
                                            placeholder={this.getText('placeholder')}
                                            disabled={disabled}
                                            readOnly={readOnly}
                                            // onBlur={(e) => this.updateAnswer(e.target.value)}
                                            autoComplete={this.getAutoComplete()}
                                            onChange = {(selectedDates, dateStr, instance) => {
                                                this.updateAnswer(dateStr);
                                            }}
                                            pickerOptions={{
                                                dateFormat: 'Y-m-d',
                                                disableMobile: readOnly || disabled, // Disable mobile input so can't input in readonly modes
                                                clickOpens: !readOnly && !disabled,
                                                allowInput: !readOnly && !disabled
                                            }}
                                        /> :
                                        <input ref="input" type="text" 
                                            // Appears to force a remount so updated defaultValue is applied. A controlled input may be better.
                                            key={'FORM-COMP- '+  Math.random()} // Always refresh key on render to ensure loading updated defaultValue
                                            className={validationFailures.length > 0 ? `form-control has-error warning-tooltip ${this.isReadOnlyAnswer() ? 'locked' : ''} ${this.getInputClassNames()}` : `form-control ${this.isReadOnlyAnswer() ? 'locked' : ''} ${this.getInputClassNames()}`}
                                            name={this.fullFieldName()}
                                            defaultValue={this.getRawAnswer()}
                                            title={validationFailures.length > 0 ? validationFailures.join('\n') : ''}
                                            data-validation={validationFailures.length > 0}
                                            placeholder={this.getText('placeholder')}
                                            disabled={disabled}
                                            readOnly={readOnly}
                                            onBlur={(e) => this.updateAnswer(e.target.value)}
                                            autoComplete={this.getAutoComplete()}
                                        />
                                    }
                                    {unit.length > 0 ? <span className="input-group-addon">{unit}</span> : null}
                                </div>
                            </div>
                        </label>
                        {this.descriptionText()}
                        {!this.modeFillOrView() && this.isReadOnlyAnswer() ? this.lockedInformationDefault() : ''}
                    </>)}
                </div>
            );
        }

        renderPrettyView() {
            const { hide = false, show_label = false } = this.props.content.prettyView || {};
            return (
                (!this.props.content.containsSensitiveInformation && !hide) ?
                <>
                    {show_label &&
                    <label>
                        <span className="field-label">{this.getText('label')}</span>
                    </label>
                    }
                    <div className="input-container">
                        <span>{this.getRawAnswer()}</span>
                    </div>
                </> :
                null
              )
        }

        renderSettings() {
            let dataTypeOptions = this.getAvailableDataTypeOptions().map((d) => {
              return [d, I18n.t('data_type_' + d, {scope: 'fe'})];
            });
            const numberFormattingOptions = this.getAvailableNumberFormattingOptions().map(formattingOption => {
                return {
                    key: formattingOption, 
                    label: I18n.t('text_field_number_formatting_option_' + formattingOption, {scope: 'fe'})
                }
            })
            let validations = this.props.content.validations || {};
            let formatOptions = [['', '']].concat([Format.URL, Format.EMAIL].map(f => [f, I18n.t('text_format_' + f, {scope: 'fe'})]));
            const NumberFormattingRadioSelection = (
                (this.props.content.dataType == DataType.INTEGER || this.props.content.dataType == DataType.DECIMAL || this.props.content.dataType == DataType.STRING) && numberFormattingOptions.length > 0
                    ?   <Setting.RadioSelection 
                            name="numberFormatting" 
                            label={I18n.t('text_field_number_formatting', {scope: 'fe'})} 
                            selectedOption={this.props.content.numberFormatting} 
                            onChange={this.updateSettings} 
                            options={numberFormattingOptions} 
                        />
                    :   <></>
            )
            
            return (
                <div>
                    {this.renderDataGridDetails()}
                    {super.isDatagridContextAvailable() && this.renderDatagridContextSettings(true)}
                    <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
                    <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
                    <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />

                    {!this.props.settings['hidePlaceholderField'] &&
                      <Setting.TextField name="placeholder" label={I18n.t('field_placeholder', {scope: 'fe'})} value={this.getText('placeholder')} onChange={this.updateSettings} />
                    }
                    {!this.props.settings['hideDescriptionField'] &&
                      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                    }
                    {!this.props.settings['hideHelpTextField'] &&
                      <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
                    }
                    <Setting.TextField name="unit" label={I18n.t('field_unit', {scope: 'fe'})} value={this.getText('unit')} onChange={this.updateSettings} />
                    <Setting.Dropdown
                      name="dataType"
                      label={I18n.t('field_data_type', {scope: 'fe'})}
                      value={this.props.content.dataType}
                      options={this.getAvailableDataTypeOptions()}
                      {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
                    />

                    {NumberFormattingRadioSelection}

                    {!this.props.settings['hideValidationFields'] && <>
                      <div className="setting">
                        <label>
                            {I18n.t('validate_range', {scope: 'fe'})}
                        </label>
                        <div className="validation-range">
                            <div className="value">
                                <input type="text" ref="validateMin" name="validateMin" className="form-control" defaultValue={validations.min} placeholder={I18n.t('validation_min', {scope: 'fe'})} onKeyUp={this.updateSettings} onBlur={(e)=> {this.props.content.dataType == DataType.DATE && this.updateSettings(e)}} autoComplete={this.getAutoComplete()} />
                            </div>
                            <div className="dash">
                                &mdash;
                            </div>
                            <div className="value">
                                <input type="text" ref="validateMax" name="validateMax" className="form-control" defaultValue={validations.max} placeholder={I18n.t('validation_max', {scope: 'fe'})} onKeyUp={this.updateSettings} onBlur={(e)=> {this.props.content.dataType == DataType.DATE && this.updateSettings(e)}} autoComplete={this.getAutoComplete()} />
                            </div>
                        </div>
                      </div>

                      {this.props.content.dataType != DataType.STRING ? null :
                        <Setting.Dropdown
                          name="validateFormat"
                          label={I18n.t('validate_format', {scope: 'fe'})}
                          value={validations.format}
                          options={formatOptions}
                          {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
                        />
                      }
                    </>}

                    <Setting.TextField name="charLimit" label={I18n.t('field_char_limit', {scope: 'fe'})} value={this.props.content.charLimit} onChange={this.updateSettings} description={I18n.t('field_char_limit_description', {scope: 'fe'})} />
                    {this.props.externalEntityLinkingCallback &&
                      <Setting.ExternalEntityLinker 
                        name="externalEntityAccessor" 
                        label={I18n.t('field_external_entity_accessor', {scope: 'fe'})} 
                        value={this.props.content.externalEntityAccessor} 
                        onChange={this.updateSettings} 
                        description={I18n.t('field_external_entity_accessor_description', {scope: 'fe'})} 
                        externalEntityLinkingCallback={this.props.externalEntityLinkingCallback} 
                        endpoint={this.props.content.endpoint}
                        parent={this.props.content.parentExternalEntityAccessor}
                      />
                    }
                    <Setting.TextField
                      name="reportKey"
                      label={I18n.t('field_report_key', {scope: 'fe'})}
                      value={this.props.content.reportKey}
                      description={I18n.t('field_report_key_description', {scope: 'fe'})}
                      {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
                    />

                    {this.renderSourcesOfPrefillSettings()}
                    <Setting.Checkbox name="lockEdit" label={I18n.t('field_lock_edit', {scope: 'fe'})} description={I18n.t('field_lock_edit_description', {scope: 'fe'})} value={this.props.content.lockEdit} onChange={this.updateSettings} />
                    {(!this.props.settings['hideLockEditWhenPrefilled'] && AppConfig.features.form_prefill) &&
                      <Setting.Checkbox name="lockEditWhenPrefilled" label={I18n.t('field_lock_edit_when_prefilled', {scope: 'fe'})} description={I18n.t('field_lock_edit_when_prefilled_description', {scope: 'fe'})} value={this.props.content.lockEditWhenPrefilled} onChange={this.updateSettings} />
                    }
                    {!this.props.settings['hideContainsSensitiveInformation'] &&
                      <Setting.Checkbox
                        name="containsSensitiveInformation"
                        label={I18n.t('field_contains_sensitive_information', {scope: 'fe'})}
                        description={I18n.t('field_contains_sensitive_information_description', {scope: 'fe'})}
                        value={this.props.content.containsSensitiveInformation}
                        {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
                      />
                    }
                    {this.renderPrettyViewSettings()}
                </div>
            );
        }

        beforeUpdateSettings(content) {
            content.validations = {};

            if ((content.validateMin || '').length > 0) {
                content.validations.min = castDataType(content.validateMin < NumericalValidationLimits.MIN ? NumericalValidationLimits.MIN : content.validateMin, content.dataType);
            }
            if ((content.validateMax || '').length > 0) {
                content.validations.max = castDataType(content.validateMax > NumericalValidationLimits.MAX ? NumericalValidationLimits.MAX : content.validateMax, content.dataType);
            }
            if ((content.validateFormat || '').length > 0) {
                content.validations.format = content.validateFormat;
                content.validations.dataType = content.dataType;
            }
            if ([DataType.INTEGER, DataType.DECIMAL, DataType.DATE].indexOf(content.dataType) != -1) {
                content.validations.dataType = content.dataType;
            }
            if (this.getAvailableNumberFormattingOptions().includes(content.numberFormatting)) {
                content.validations.numberFormatting = content.numberFormatting;
            }

            content.required = castDataType(content.required, DataType.BOOLEAN);
            content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
            content.charLimit = castDataType(content.charLimit, DataType.INTEGER);
            content.currency = castDataType(content.currency, DataType.BOOLEAN);
            content.lockEditWhenPrefilled = castDataType(content.lockEditWhenPrefilled, DataType.BOOLEAN);
            content.lockEdit = castDataType(content.lockEdit, DataType.BOOLEAN);

            if (super.isDatagridContextAvailable()) {
                content.datagridId = castDataType(content.datagridId, DataType.INTEGER);
                content.presetId = castDataType(content.presetId, DataType.INTEGER);
                content.columnAccessor = castDataType(content.columnAccessor, DataType.STRING);

                content.dependencyMapping = []

                Object.keys(content).filter((k) => { return k.match(/^dependencyMapping\|/); }).forEach((k) => {
                    let parts = k.split('|'); // dependencyMapping|colId|index|attr

                    if (parts[3] == 'componentId') {
                        content.dependencyMapping[parts[2]] ||= {}
                        content.dependencyMapping[parts[2]]['colId'] = parts[1]
                        content.dependencyMapping[parts[2]][parts[3]] = content[k] || '';
                    }
                    delete content[k];
                });
            }
            this.beforeUpdateSettingsPrettyView(content);
        }

        getAvailableDataTypeOptions() {
            // Remove functionality for selecting INTEGER/DECIMAL types from newly added components (Use NumberField instead)
            return [DataType.STRING, DataType.DATE].includes(this.props.content.dataType) && this.props.content.numberFormatting == NumberFormatting.NONE ?
                [DataType.STRING, DataType.DATE] : [DataType.STRING, DataType.INTEGER, DataType.DECIMAL, DataType.DATE]
        }

        getAvailableNumberFormattingOptions() {
            // Remove functionality for selecting number/currency formats from newly added components (Use NumberField instead)
            return [DataType.STRING, DataType.DATE].includes(this.props.content.dataType) && this.props.content.numberFormatting == NumberFormatting.NONE ?
                [] : [NumberFormatting.NONE, NumberFormatting.CURRENCY, NumberFormatting.NUMBER]
        }
}
